import React, { useEffect, useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import ProductCard from "./components/ProductCard";
import { Btn } from "../../AbstractElements";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import CustomInput from "../../Component/BasicComponents/CustomInput";
import OrderBillCard from "./components/OrderBillCard";
import {
  useAddOrderLines,
  useCalculateOrderLinesSubTotal,
  useDeleteOrderLines,
  useOrderListByIdData,
  useProductsByPricebookIdData,
  useRejectOrder,
  useUpdateAcceptOrder,
  useUpdateOrderLines,
} from "./hooks/usePOB";
import { useLocation, useNavigate } from "react-router-dom";
import ReusableDropdown from "../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { FaEdit } from "react-icons/fa";
import { showToast } from "../../utils/toastUtils";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { BASE_URL } from "../../Api/config";

const POBOrderView = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAcceptModal, setIsAcceptModal] = useState(false);
  const [itemModalStatus, setItemModalStatus] = useState("");
  const [acceptClickStatus, setAcceptClickStatus] = useState("");
  const [remark, setRemark] = useState("");
  const [formValues, setFormValues] = useState({
    orderLineId: "",
    products: "",
    pricebooklineid: "",
    rate: "",
    qty: "",
    remark: "",
    productName: "",
    subtotal: "",
    mrp: "",
    pricebookId: "",
    unitId: "",
  });
  const [selectedRowData, setSelectedRowData] = useState<any>(null);

  const [showPdfModalOpen, setShowPdfModalOpen] = useState(false);
  const [termCondition, setTermCondition] = useState("");

  const [updateButtonDisable, setUpdateButtonDisable] = useState(false);
  const [finalOrderButtonDisable, setFinalOrderButtonDisable] = useState(false);
  const [finalOrderButtonDisableReject, setFinalOrderButtonDisableReject] =
    useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { OrderId } = location?.state || {};

  const { data: orderListByIdData, isLoading: isOrderListByIdDataLoading } =
    useOrderListByIdData({
      id: OrderId,
      enable: true,
    });

  const isValid =
    formValues?.rate !== undefined &&
    formValues?.rate !== null &&
    formValues?.rate !== "" &&
    formValues?.qty !== undefined &&
    formValues?.qty !== null &&
    formValues?.qty !== "";
  const { data: calculateOrderLinesSubTotal } = useCalculateOrderLinesSubTotal({
    enable: isValid,
    params: {
      rate: formValues?.rate,
      quantity: formValues?.qty,
    },
  });

  useEffect(() => {
    if (
      formValues?.qty === "" ||
      formValues?.qty === null ||
      formValues?.qty === undefined
    ) {
      setFormValues((prev) => ({
        ...prev,
        subtotal: "",
      }));
    }
  }, [formValues?.qty]);

  useEffect(() => {
    if (
      calculateOrderLinesSubTotal &&
      Array.isArray(calculateOrderLinesSubTotal?.data)
    ) {
      const newSubtotal = calculateOrderLinesSubTotal?.data[0]; // e.g., 400
      setFormValues((prev) => ({
        ...prev,
        subtotal: newSubtotal,
      }));
    }
  }, [calculateOrderLinesSubTotal]);

  const priceBookId = orderListByIdData?.data?.orderData?.PricebookId;
  const { data: ProductsByPricebookId } = useProductsByPricebookIdData({
    id: priceBookId,
    enable: !!priceBookId, // Only true if pricebookId exists,
  });

  const productsData = ProductsByPricebookId?.data.map(
    (item: any, index: any) => ({
      id: item?.productId,
      label: item?.productName,
    })
  );

  const { mutate: AcceptMutate } = useUpdateAcceptOrder();
  // const { mutate: DeleteMutate } = useDeleteOrder();
  const { mutate: AddOrderLines } = useAddOrderLines();
  const { mutate: UpdateOrderLines } = useUpdateOrderLines();
  const { mutate: DeleteOrderLine } = useDeleteOrderLines();
  const { mutate: RejectOrder } = useRejectOrder();

  const formattedOrderLinesData = orderListByIdData?.data?.orderLines.map(
    (item: any, index: any) => ({
      ...item,
      Sr: index + 1,
    })
  );

  const handleAddOrder = () => {
    setItemModalStatus("ADD");
    setIsModalOpen(true);
  };

  const handleItemEdit = (row: any) => {
    setItemModalStatus("EDIT");
    setIsModalOpen(true);
    setSelectedRowData(row);
  };

  const handleAcceptOrder = () => {
    setRemark("");
    setIsAcceptModal(true);
    setAcceptClickStatus("Accept");
  };

  const handleDeleteOrder = () => {
    setIsAcceptModal(true);
    setAcceptClickStatus("Delete");
  };

  const handleAcceptFinalOrder = () => {
    if (!OrderId) return;

    if (!remark) {
      showToast.warning("Please Fill Order Remark!");
      return;
    }

    const body = {
      remark: remark,
    };
    AcceptMutate(
      {
        id: OrderId,
        body,
      },
      {
        onSuccess: () => {
          setIsAcceptModal(false);
          navigate("/pobOrdersList");
          setRemark("");
        },
        onSettled: () => {
          setIsAcceptModal(false);
          // navigate("/pobOrdersList");
          setRemark("");
          setFinalOrderButtonDisable(false);
        },
      }
    );
    setFinalOrderButtonDisable(true);
  };

  const handleDeleteFinalOrder = () => {
    if (!OrderId) return;

    if (!remark) {
      showToast.warning("Please Fill Order Remark!");
      return;
    }
    const body = {
      remark: remark,
    };

    RejectOrder(
      { id: OrderId, body },

      {
        onSuccess: () => {
          setIsAcceptModal(false);
          navigate("/pobOrdersList");
          setRemark("");
        },
        onSettled: () => {
          setIsAcceptModal(false);
          // navigate("/pobOrdersList");
          setRemark("");
          setFinalOrderButtonDisableReject(false);
        },
      }
    );
    setIsAcceptModal(false);
    setFinalOrderButtonDisableReject(true);
  };

  const handleDropdownSelect = (field: string, value: string | number) => {
    const selectedProduct = ProductsByPricebookId?.data.find(
      (product: any) => Number(product.productId) === Number(value)
    );

    setFormValues((prevState: any) => ({
      ...prevState,
      [field]: value, // Directly assign the selected value
      rate: selectedProduct?.rate || "", // auto-fill rate from selected product
      productName: selectedProduct?.productName || "",
      subtotal: selectedProduct?.subtotal || "",
      mrp: selectedProduct?.mrp || "",
      pricebooklineid: selectedProduct?.pricebookLineId || "",
      unitId: selectedProduct?.unitId || "",
      pricebookId: priceBookId,
    }));
  };

  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;
    console.log(`${name}----${value}`);

    // Convert specific fields to numbers
    const numericFields = ["qty"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "") // Allow only numbers
      : value; // Keep string values as they are

    setFormValues((prevState) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };

  const handlePrintOrderPDF = () => {
    setShowPdfModalOpen(!showPdfModalOpen);
  };

  // const handleDownloadPDF = async () => {
  //   try {
  //     setIsDownloading(true); // 🔒 disable button
  //     const AppToken = localStorage.getItem("Apptoken");
  //     if (AppToken) {
  //       const response = await fetch(
  //         `${BASE_URL}${API_ENDPOINTS.POB.PRINT_ORDER}/${OrderId}`,
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/pdf",
  //             accept: "application/pdf",
  //             apptoken: AppToken,
  //           },
  //           body: JSON.stringify({
  //             termsAndConditions: termCondition || "",
  //           }),
  //         }
  //       );

  //       if (!response.ok) {
  //         throw new Error("Failed to download PDF");
  //       }

  //       // ✅ Get raw PDF binary
  //       const arrayBuffer = await response.arrayBuffer();
  //       const blob = new Blob([arrayBuffer], { type: "application/pdf" });

  //       // ✅ Trigger browser download
  //       const url = window.URL.createObjectURL(blob);
  //       const link = document.createElement("a");
  //       link.href = url;
  //       // link.download = "order.pdf";
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //       URL.revokeObjectURL(url);

  //       showToast.success("Download PDF Successfully!");
  //     }
  //   } catch (error) {
  //     console.error("PDF download error:", error);
  //     showToast.warning("Failed to download PDF!");
  //   } finally {
  //     setIsDownloading(false);
  //     setShowPdfModalOpen(false);
  //     setTermCondition("");
  //   }
  // };

  const handleDownloadPDF = async () => {
    try {
      setIsDownloading(true); // 🔒 disable button

      const AppToken = localStorage.getItem("Apptoken");
      if (!AppToken) {
        showToast.warning("Missing App Token!");
        return;
      }

      const response = await fetch(
        `${BASE_URL}${API_ENDPOINTS.POB.PRINT_ORDER}/${OrderId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // 🔄 Correct for body JSON
            accept: "application/pdf",
            apptoken: AppToken,
          },
          body: JSON.stringify({
            termsAndConditions: termCondition || "",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to download PDF");
      }

      // ✅ Convert to blob
      const blob = await response.blob();

      // ✅ Extract filename from headers (if backend sends one)
      const disposition = response.headers.get("Content-Disposition");
      let fileName = "order.pdf";
      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          fileName = match[1];
        }
      }

      // ✅ Create blob link and trigger download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      // 🧹 Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      // showToast.success("PDF downloaded successfully!");
    } catch (error) {
      console.error("PDF download error:", error);
      showToast.warning("Failed to download PDF!");
    } finally {
      setIsDownloading(false);
      setShowPdfModalOpen(false);
      setTermCondition("");
    }
  };

  useEffect(() => {
    if (itemModalStatus === "EDIT" && selectedRowData) {
      setFormValues({
        orderLineId: selectedRowData?.OrderlineId,
        products: selectedRowData?.ProductId,
        pricebooklineid: selectedRowData?.PricebookLineId,
        rate: selectedRowData?.Rate,
        qty: selectedRowData?.Qty,
        remark: selectedRowData?.Remark == "0" ? "" : selectedRowData?.Remark,
        productName: selectedRowData?.ProductName,
        subtotal: selectedRowData?.TotalAmt,
        mrp: selectedRowData?.Mrp,
        pricebookId: priceBookId,
        unitId: selectedRowData?.UnitId,
      });
    } else {
      setFormValues({
        orderLineId: "",
        products: "",
        pricebooklineid: "",
        rate: "",
        qty: "",
        remark: "",
        productName: "",
        subtotal: "",
        mrp: "",
        pricebookId: "",
        unitId: "",
      });
    }
  }, [itemModalStatus]);

  const handleAddUpdate = () => {
    if (itemModalStatus === "EDIT") {
      const body = {
        orderLineId: formValues?.orderLineId,
        productId: formValues?.products,
        pricebookLineId: formValues?.pricebooklineid,
        productName: formValues?.productName,
        rate: formValues?.rate,
        quantity: formValues?.qty,
        subtotal: formValues?.subtotal,
        mrp: formValues?.mrp,
        unitId: formValues?.unitId,
        remark: formValues?.remark,
      };

      UpdateOrderLines(
        { id: OrderId, body },
        {
          onSuccess: () => {
            setIsModalOpen(false);
            setFormValues({
              orderLineId: "",
              products: "",
              pricebooklineid: "",
              rate: "",
              qty: "",
              remark: "",
              productName: "",
              subtotal: "",
              mrp: "",
              pricebookId: "",
              unitId: "",
            });
            setItemModalStatus("");
            setUpdateButtonDisable(false);
          },
          onError: (error) => {
            setUpdateButtonDisable(false);
            console.log("UPDATE ORDER LINES :::::::::", error);
          },
        }
      );
      setUpdateButtonDisable(true);
    } else {
      const body = {
        productId: formValues?.products,
        pricebookLineId: formValues?.pricebooklineid,
        productName: formValues?.productName,
        rate: formValues?.rate,
        quantity: formValues?.qty,
        subtotal: formValues?.subtotal,
        mrp: formValues?.mrp,
        pricebookId: formValues?.pricebookId,
        unitId: formValues?.unitId,
        remark: formValues?.remark,
      };
      AddOrderLines(
        { id: OrderId, body },
        {
          onSuccess: () => {
            setIsModalOpen(false);
            setItemModalStatus("");
            setFormValues({
              orderLineId: "",
              products: "",
              pricebooklineid: "",
              rate: "",
              qty: "",
              remark: "",
              productName: "",
              subtotal: "",
              mrp: "",
              pricebookId: "",
              unitId: "",
            });
            setUpdateButtonDisable(false);
          },
          onError: (error) => {
            setUpdateButtonDisable(false);
            console.log("ERROR IN ADDORDERLINES ::::::::::::::", error);
          },
        }
      );
      setUpdateButtonDisable(true);
    }
  };

  const handleDeleteOrderLines = () => {
    const DeleteBody = {
      orderLineId: formValues?.orderLineId,
    };

    setFinalOrderButtonDisableReject(true);

    DeleteOrderLine(
      { id: OrderId, body: DeleteBody },
      {
        onSuccess: () => {
          setIsModalOpen(false);
        },
        onSettled: () => {
          setIsModalOpen(false);
          setFormValues({
            orderLineId: "",
            products: "",
            pricebooklineid: "",
            rate: "",
            qty: "",
            remark: "",
            productName: "",
            subtotal: "",
            mrp: "",
            pricebookId: "",
            unitId: "",
          });
          // setUpdateButtonDisable(false);
          setFinalOrderButtonDisableReject(false);
        },
      }
    );
    // setUpdateButtonDisable(true);
    setFinalOrderButtonDisableReject(true);
  };

  const status = orderListByIdData?.data?.orderData?.OrderStatus;
  const disable =
    status === "Accepted" || status === "Rejected" || status === "Completed";

  console.log(
    "orderListByIdData?.data?.orderLogs::",
    orderListByIdData?.data?.orderLogs
  );

  return (
    <div className="p-2">
      <PageHeader
        title="Order View"
        buttons={[
          {
            label: "Print Order",
            // onClick: () => printPDF(PrintOrderData), // 👈 This triggers the browser print dialog
            onClick: handlePrintOrderPDF, // 👈 This triggers the browser print dialog
            color: "#43B9B2",
          },
        ]}
      />
      <div
        // className="container"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <div style={{ flex: "1", minWidth: "70%", maxWidth: "100%" }}>
          <OrderBillCard
            orderListByIdData={orderListByIdData}
            isOrderListByIdDataLoading={isOrderListByIdDataLoading}
          />
          <div style={{ height: 20 }} />
          <BasicDataTable
            search={false}
            Title="Items"
            columns={ItemsListColumns(handleItemEdit, disable)}
            data={formattedOrderLinesData || []}
            topLeftAlignContent={
              <>
                {!disable && (
                  <div>
                    <Btn
                      onClick={() => {
                        // setIsModalOpen(true);
                        handleAddOrder();
                      }}
                      style={{ backgroundColor: "#2e8dd3", color: "white" }}
                      type="button"
                    >
                      + Add Items
                    </Btn>
                  </div>
                )}
              </>
            }
          />
          <div style={{ height: 20 }} />
          <BasicDataTable
            search={false}
            Title="Order Logs"
            columns={LogsListColumns}
            data={orderListByIdData?.data?.orderLogs || []}
          />
        </div>
        <div style={{ minWidth: "28%", maxWidth: "100%" }}>
          <ProductCard
            orderListByIdData={orderListByIdData}
            isOrderListByIdDataLoading={isOrderListByIdDataLoading}
          />
          {orderListByIdData?.data?.orderData?.OrderStatus &&
            orderListByIdData.data.orderData.OrderStatus !== "Accepted" &&
            orderListByIdData.data.orderData.OrderStatus !== "Rejected" &&
            orderListByIdData.data.orderData.OrderStatus !== "Completed" && (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <button
                  className="btn btn-primary"
                  style={{
                    borderRadius: "5px",
                    width: "100%",
                    height: "fit-content",
                    // backgroundColor: "#2e8dd3",
                    margin: 2,
                  }}
                  onClick={handleAcceptOrder}
                >
                  Accept Order
                </button>
                <button
                  className="btn btn-primary"
                  style={{
                    borderRadius: "5px",
                    width: "100%",
                    height: "fit-content",
                    backgroundColor: "#E32020",
                    margin: 2,
                    border: "#E32020",
                  }}
                  onClick={handleDeleteOrder}
                >
                  Reject Order
                </button>
              </div>
            )}
        </div>
      </div>
      <RouteModal
        isOpen={isModalOpen}
        toggle={() => {
          setIsModalOpen(!isModalOpen);
          setFormValues({
            orderLineId: "",
            products: "",
            pricebooklineid: "",
            rate: "",
            qty: "",
            remark: "",
            productName: "",
            subtotal: "",
            mrp: "",
            pricebookId: "",
            unitId: "",
          });
          setItemModalStatus("");
          setUpdateButtonDisable(false);
        }}
        title={itemModalStatus === "ADD" ? "Add Product" : "Edit Product"}
        size="md"
        content={
          <div className="row mb-0">
            <ReusableDropdown
              options={productsData || []}
              onChange={(value: any) => {
                handleDropdownSelect("products", value);
              }}
              DropdownHeading="Product*"
              value={formValues?.products}
              placeholder={"Select Products..."}
            />
            <div className="d-flex justify-content-start gap-2">
              <CustomInput
                disabled={true}
                label="MRP*"
                placeholder=""
                type="text"
                name="rate"
                value={formValues?.mrp}
                onChange={(e) => handleInputChange("mrp", e)}
              />
              <CustomInput
                disabled={true}
                label="Rate*"
                placeholder=""
                type="text"
                name="rate"
                value={formValues?.rate}
                onChange={(e) => handleInputChange("rate", e)}
              />
            </div>
            <div className="d-flex justify-content-start gap-2">
              <CustomInput
                label="Quantity*"
                placeholder=""
                type="number"
                name="qty"
                value={formValues?.qty}
                onChange={(e) => handleInputChange("qty", e)}
              />
              <CustomInput
                label="Sub Total"
                placeholder=""
                type="text"
                name="remark"
                disabled={true}
                value={formValues?.qty === "" ? "" : formValues?.subtotal}
                // onChange={handleInputChange}
              />
            </div>
            <CustomInput
              label="Remark"
              placeholder=""
              type="text"
              name="remark"
              value={formValues?.remark}
              onChange={(e) => handleInputChange("remark", e)}
            />

            <div style={{ height: 10 }} />
            <div className="d-flex justify-content-start gap-2">
              <Btn
                style={{ backgroundColor: "#43B9B2", color: "white" }}
                type="submit"
                onClick={handleAddUpdate}
                disabled={updateButtonDisable || finalOrderButtonDisableReject}
              >
                {itemModalStatus === "ADD" ? "Submit" : "Update"}
              </Btn>
              <Btn
                style={{
                  backgroundColor: "#F9FAFC",
                  color: "#000",
                  border: "1px solid #E0E0E0",
                }}
                type="button"
                disabled={updateButtonDisable || finalOrderButtonDisableReject}
                onClick={() => {
                  setIsModalOpen(false);
                  setFormValues({
                    orderLineId: "",
                    products: "",
                    pricebooklineid: "",
                    rate: "",
                    qty: "",
                    remark: "",
                    productName: "",
                    subtotal: "",
                    mrp: "",
                    pricebookId: "",
                    unitId: "",
                  });
                  setItemModalStatus("");
                  setUpdateButtonDisable(false);
                }}
              >
                Cancel
              </Btn>
              {itemModalStatus === "EDIT" && (
                <Btn
                  style={{
                    backgroundColor: "#d35400",
                    color: "#ffffffff",
                    border: "1px solid #E0E0E0",
                  }}
                  type="button"
                  onClick={handleDeleteOrderLines}
                  disabled={
                    finalOrderButtonDisableReject || updateButtonDisable
                  }
                >
                  Delete
                </Btn>
              )}
            </div>
          </div>
        }
      />

      <RouteModal
        isOpen={isAcceptModal}
        toggle={() => {
          setIsAcceptModal(!isAcceptModal);
        }}
        title={acceptClickStatus === "Accept" ? "Accept Order" : "Reject Order"}
        size="md"
        content={
          <div className="row mb-0">
            {acceptClickStatus === "Accept" && (
              <CustomInput
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                label="Remark"
                placeholder=""
                asterisk={true}
                type="text"
              />
            )}

            <div style={{ height: 10 }} />
            <div className="d-flex justify-content-start gap-2">
              {acceptClickStatus === "Accept" && (
                <div style={{ width: "100%" }}>
                  <Btn
                    style={{
                      backgroundColor: "#43B9B2",
                      color: "white",
                      marginRight: "10px",
                    }}
                    type="submit"
                    onClick={handleAcceptFinalOrder}
                    disabled={finalOrderButtonDisable}
                  >
                    Accept Order
                  </Btn>
                  <Btn
                    style={{
                      backgroundColor: "#F9FAFC",
                      color: "#000",
                      border: "1px solid #E0E0E0",
                    }}
                    type="button"
                    onClick={() => {
                      setIsAcceptModal(false);
                      setFinalOrderButtonDisable(false);
                      setRemark("");
                    }}
                  >
                    Cancel
                  </Btn>
                </div>
              )}
              {acceptClickStatus !== "Accept" && (
                <div style={{ width: "100%" }}>
                  <CustomInput
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    label="Remark"
                    placeholder=""
                    type="text"
                    asterisk={true}
                  />
                  <div style={{ width: "100%" }}>
                    <Btn
                      style={{
                        backgroundColor: "#d35400",
                        color: "#ffffffff",
                        border: "1px solid #E0E0E0",
                        marginRight: "10px",
                      }}
                      type="button"
                      onClick={handleDeleteFinalOrder}
                      disabled={finalOrderButtonDisable}
                    >
                      Reject Order
                    </Btn>

                    <Btn
                      style={{
                        backgroundColor: "#F9FAFC",
                        color: "#000",
                        border: "1px solid #E0E0E0",
                        marignLeft: "10px",
                      }}
                      type="button"
                      onClick={() => {
                        setIsAcceptModal(false);
                        setFinalOrderButtonDisable(false);
                        setRemark("");
                      }}
                    >
                      Cancel
                    </Btn>
                  </div>
                </div>
              )}
              {/* <Btn
                style={{
                  backgroundColor: "#F9FAFC",
                  color: "#000",
                  border: "1px solid #E0E0E0",
                }}
                type="button"
                onClick={() => {
                  setIsAcceptModal(false);
                }}
              >
                Cancel
              </Btn> */}
            </div>
          </div>
        }
      />

      <RouteModal
        isOpen={showPdfModalOpen}
        title={"Download PDF"}
        size="sm"
        content={
          <>
            <CustomInput
              label="Term & Condition"
              placeholder="Enter Term & Condition"
              type="text"
              name="name"
              value={termCondition}
              onChange={(e) => setTermCondition(e.target.value)}
            />
            <div style={{ display: "flex", flexDirection: "row" }}>
              <Btn
                style={{ backgroundColor: "#43B9B2", color: "white" }}
                type="submit"
                disabled={isDownloading}
                onClick={handleDownloadPDF}
              >
                Download PDF
              </Btn>

              <button
                onClick={() => {
                  setShowPdfModalOpen(!showPdfModalOpen);
                  setTermCondition("");
                }}
                className="btn btn-light"
                style={{ color: "gray", marginLeft: "10px" }}
              >
                Cancel
              </button>
            </div>
          </>
        }
      />
    </div>
  );
};

export default POBOrderView;

const ItemsListColumns = (
  handleItemEdit: (row: any) => void,
  disable: boolean
) => [
  {
    name: "Id",
    selector: (row: { Sr: number | string }) => row?.Sr || "-",
    sortable: true,
    minWidth: "80px",
  },
  {
    name: "Item",
    selector: (row: { ProductName: string }) => row.ProductName || "-",
    sortable: true,
    wrap: true,
    minWidth: "200px",
  },
  {
    name: "MRP",
    selector: (row: { Mrp: string | number }) => row?.Mrp || "-",
    sortable: true,
    sortFunction: (a: any, b: any) => {
      return Number(a.Mrp) - Number(b.Mrp);
    },
    minWidth: "120px",
  },
  {
    name: "Rate",
    selector: (row: { Rate: string | number }) => row?.Rate || "-",
    sortable: true,
    sortFunction: (a: any, b: any) => {
      return Number(a.Rate) - Number(b.Rate);
    },
    minWidth: "120px",
  },
  {
    name: "Quantity",
    selector: (row: { Qty: string | number }) => row?.Qty || "-", // (depend by backend)
    sortable: true,
    minWidth: "120px",
  },
  {
    name: "Shipped Qty.",
    selector: (row: { ShipQty: string | number }) =>
      row?.ShipQty !== "" || null || undefined ? row?.ShipQty : "-", // (depend by backend)
    sortable: true,
    wrap: true,
    minWidth: "150px",
    sortFunction: (a: any, b: any) => {
      return Number(a.ShipQty) - Number(b.ShipQty);
    },
  },
  {
    name: "Discount",
    selector: (row: { Margin: string | number }) => row?.Margin ?? "-",
    sortable: true,
    sortFunction: (a: any, b: any) => {
      return Number(a.Margin) - Number(b.Margin);
    },
    minWidth: "120px",
  },
  {
    name: "Discount Percentage",
    selector: (row: { DiscountPercent: string | number }) =>
      row?.DiscountPercent ?? "-",
    sortable: true,
    sortFunction: (a: any, b: any) => {
      return Number(a.DiscountPercent) - Number(b.DiscountPercent);
    },
    minWidth: "200px",
  },

  {
    name: "Sub Total",
    selector: (row: { Subtotal: string }) => row?.Subtotal || "-", // (depend by backend)
    sortable: true,
    minWidth: "150px",
  },
  {
    name: "Action",
    cell: (row: any) => (
      <>
        <button
          onClick={() => handleItemEdit(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "20px",
            padding: "5px",
            width: "80px",
            backgroundColor: disable ? "gray" : "#43B9B2",
            color: "white",
            borderColor: disable ? "gray" : "",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "2px",
          }}
          disabled={disable}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      </>
    ),
  },
];
const LogsListColumns = [
  {
    name: "Log Details",
    selector: (row: { Description: number | string }) => row.Description || "-",
    sortable: true,
    wrap: true,
  },
  {
    name: "Description",
    selector: (row: { Title: string }) => row?.Title || "-",
    sortable: true,
    wrap: true,
  },
  {
    name: "Log By",
    selector: (row: { UserFullName: string | number }) =>
      row?.UserFullName || "-",
    sortable: true,
    wrap: true,
    minWidth: "120px",
  },
  {
    name: "Log Date & Time",
    selector: (row: { LogDate: string | number }) => row?.LogDate || "-", // (depend by backend)
    sortable: true,
    wrap: true,
  },
];
